const givingProfilePath = "/giving/profile"

export const ProfileNavItems = [
  { label: "Overview", path: givingProfilePath },
  {
    label: "Donation history",
    path: `${givingProfilePath}/donations`,
  },
  {
    label: "Planned giving",
    path: `${givingProfilePath}/planned`,
  },
  {
    label: "Payment methods",
    path: `${givingProfilePath}/payment-methods`,
  },
  {
    label: "Text2Give",
    path: `${givingProfilePath}/text-to-give`,
  },
  {
    label: "Notifications",
    path: `${givingProfilePath}/notifications`,
  },
  {
    label: "Statements",
    path: `${givingProfilePath}/statements`,
  },
] as const

export type ProfileNav = (typeof ProfileNavItems)[number]

export type SendsReceiptsValue = "always" | "never"

export type SendsReceiptsOption = {
  label: string
  value: SendsReceiptsValue
}

export type GivingPerson = {
  email_addresses: string[]
  giving_preferred_email_address: string | null
  sends_receipts: SendsReceiptsValue
  can_view_text2give_settings: boolean
}

export type Organization = {
  id: string
  name: string
  text2give_enabled: boolean
  text2give_phone_number: string | null
  credit_cards_allowed: boolean
}

export type Text2GivePhoneNumber = {
  id: string
  phone_number: string
  payment_method_id: string | null
}

export type PaymentMethod = {
  id: string
  brand: string | null
  last4: string | null
}

export type Statement = {
  id: string
  amount_cents: number
  amount_currency: string
  created_at: string
  starts_on: string
  ends_on: string
  donation_count: number
  download_url: string
  name: string
}
